import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const CardItemWrapper = styled.div`
  height: 300px;
  padding: 15px;
  width: 25%;
  min-width: 250px;
  ${mediaQuery('desktop')} {
    width: ${(1 / 3) * 100}%;
  }
  ${mediaQuery('medium')} {
    width: 50%;
  }

  ${mediaQuery('phone')} {
    min-width: auto;
    width: 100%;
  } ;
`;
